import { type ReactNode, createContext, useContext, useMemo } from 'react';

export type EditorMode = 'read' | 'edit';

interface EditorContextValue {
  mode: EditorMode;
}

const EditorContext = createContext<EditorContextValue>({ mode: 'read' });

interface EditorContextProviderProps {
  mode: EditorMode;
  children: ReactNode;
}

export function EditorContextProvider({ mode, children }: EditorContextProviderProps) {
  const value = useMemo(() => ({ mode }), [mode]);
  return <EditorContext.Provider value={value}>{children}</EditorContext.Provider>;
}

export function useEditorMode(): EditorMode {
  return useContext(EditorContext).mode;
}
